//import room1 from "./images/audiance.jpg";
import room1 from "./images/1st-blog.jpg";
import blog2 from "./images/2nd-blog.jpg";
import blog3 from "./images/3rd-blog.jpg";
import room2 from "./images/campaign.jpg";
import room3 from "./images/desk.png";
import room4 from "./images/digital_marketing.jpg";
import img1 from "./images/growth_hacking.jpg";
import img2 from "./images/like.jpg";
import img3 from "./images/seo.jpg";
import img4 from "./images/social-media.jpg";
import img5 from "./images/targeting.jpg";

export default [
  {
    sys: {
      id: "1",
    },
    fields: {
      name: "ফেসবুক বিজ্ঞাপন কি?",
      slug: "ফেসবুক-বিজ্ঞাপন-কি",
      type: "single",
      featured: true,

      description: `  <p class="card-text text_justify">বিজ্ঞাপন হল কোনো পন্য বা সেবার তথ্য মানুষকে জানানো যাতে মানুষজন 
      সেই পন্য সম্পর্কে জানতে পারে এবং সেটির প্রতি আগ্রহ তৈরী করে পন্যটি কেনার জন্য সিদ্ধান্ত নেয়। তেমনি ফেসবুক বিজ্ঞাপন হল 
      এমন এক ধরনের কার্যকরী বিজ্ঞাপন যেটি আপনি আপনার ফেসবুক পেজ থেকে কোনো পোস্ট বা ছবি বা ভিডিও আকারে কোনো নির্দিষ্ট 
      অঞ্চলের মানুষদের দেখাবেন ।
      <br></br>
        মানে হল, আপনার পেজে যারা যারা লাইক দেইনি তাদেরকে আপনার পেজের পন্য বা সেবা সম্পর্কে ধারণা দেয়ার জন্য আপনি 
        ফেসবুকে বিজ্ঞাপন দিবেন। বর্তমানে বাংলাদেশে ৩ কোটি মানুষ ফেসবুক ব্যবহার করছে। তার মানে প্রতি ৫ জনের এক জনে ফেসবুক 
        ব্যবহার করছে। ফলে ফেসবুক বিজ্ঞাপনের গুরুত্ব দিন দিন বেড়েই চলছে।
        <br></br>
        ফেসবুক বিজ্ঞাপনের মাধ্যমে ব্যবসায়ীদের প্রতিষ্ঠানের নাম ও পন্যের তথ্য মুহুর্তের মধ্যে লাখো মানুষের কাছে পৌঁছে দেওয়া যায়। আর 
        এই বিজ্ঞাপনের পর বিজ্ঞাপনের বিভিন্ন দিক যেমন কত জন বিজ্ঞানটি দেখেছে?কত জন বিজ্ঞাপনটির উপর ক্লিক করেছে?কত জন
         বিজ্ঞাপনটির প্রতি আগ্রহ প্রকাশ করেছে এটি নিখুঁতভাবে জানা যায়।
         <br></br>
        তাই বর্তমানে পত্রিকা, টিভি, বিলবোর্ড ও লিফলেট বিজ্ঞাপনের চেয়ে ফেসবুক বিজ্ঞাপন অত্যন্ত গুরুত্বপূর্ণ ও অধিক কার্যকরী হয়ে 
        উঠেছে।</p> `,
      extras:
        "বিজ্ঞাপন হল কোনো পন্য বা সেবার তথ্য মানুষকে জানানো যাতে মানুষজন সেই পন্য সম্পর্কে জানতে পারে এবং সেটির প্রতি আগ্রহ তৈরী করে পন্যটি কেনার জন্য সিদ্ধান্ত ... ",
      images: [
        {
          fields: {
            file: {
              url: room1,
            },
          },
        },
        {
          fields: {
            file: {
              url: room2,
            },
          },
        },
        {
          fields: {
            file: {
              url: room3,
            },
          },
        },
        {
          fields: {
            file: {
              url: room4,
            },
          },
        },
      ],
    },
  },
  {
    sys: {
      id: "2",
    },
    fields: {
      name: "কেনো ফেসবুকে বিজ্ঞাপন দিবেন ?",
      slug: "কেনো-ফেসবুকে-বিজ্ঞাপন-দিবেন",
      type: "single",

      featured: true,
      description: `
       <p class="card-text text_justify"> বর্তমানে ফেসবুক বিশ্বের সবচেয়ে জনপ্রিয় একটি স্যোসাল মাধ্যম যা বিশ্বের প্রায় আড়াই কোটি মানুষ ব্যবহার করে থাকে । 
        বাংলাদেশের প্রায় ৩ কোটি মানুষের ফেসবুক একাউন্ট রয়েছে । এদের মধ্যে ১৮-৩৫ বছর বয়সীদের সংখ্যা ৭০ ভাগ এর মত এবং 
        বাকীদের সংখ্যা ৩০ ভাগ । তাই ফেসবুক বিজ্ঞাপনের মাধ্যমে আপনি এই ৩ কোটি মানুষের কাছে পৌঁছাতে পারবেন আপনার 
        বিজ্ঞাপনের বিষয়বস্তু ।</p>
        <br></br> 
                             <h3 class="card-title text-center">ফেসবুক বিজ্ঞাপনের কিছু সুবিধাসমূহঃ</h3>
        
        <hr></hr>
        <p className="card-text text_justify">
        <strong>স্মার্ট মাধ্যমঃ</strong>
        এক গবেষণায় দেখা গেছে বাংলাদেশের একজন ইন্টারনেট ব্যবহারকারী দৈনিক গড়ে ১৫০ বার ফোনের স্ক্রীন চেক করে 
        এবং ঘুম থেকে উঠে ৪৮ ভাগ মানুষ ফেসবুক চেক করে । সুতরাং ফেসবুকে এসকল মানুষদেরকে বিজ্ঞাপন দেখানোটা খুবই সহজ ।
        আর তাছাড়া মানুষ এখন খবরের কাগজ , টেলিভিশন, পোস্টারের বিজ্ঞাপনের চেয়ে মোবাইলে বিজ্ঞাপন দেখতে সাচ্ছন্দ্যবোধ করে 
        যেহেতু এটা খুব সহজে এবং স্মার্টলি দেখা যায় । বর্তমানে টেলিভিশন ও খবরের কাগজ থেকেই মানুষ মোবাইল ফোনে বেশি সময় ব্যয়
        করে।
        <br></br> 
        <strong>কম খরচেঃ</strong> টেলিভিশন , খবরের কাগজ, রেডিও ও পোস্টার বিজ্ঞাপনের চেয়ে খুব কম খরচে ফেসবুক বিজ্ঞাপন দেয়া যায় । মাত্র 
        ১ ডলার( ব্যাংক রেট ৮৫ টাকা) দিয়ে ৫০০-১৫০০ জন টার্গেটেড মানুষকে ২৪ ঘন্টার জন্য ফেসবুকে বিজ্ঞাপন দেখাতে পারবেন যা 
        অন্যান্য মাধ্যমে হয়তো সম্ভব নয় ।
        <br></br> 
        <strong>ট্র্যাকিং সুবিধাঃ</strong> কত জন আপনার বিজ্ঞাপনটি দেখেছে ? কত জন আপনার বিজ্ঞাপনের উপর ক্লিক করেছে ? কত জন লাইক ও
        কমেন্ট করেছে ? তা বিজ্ঞাপন চলাকালীন সময়ে আপনি জানতে পারবেন । ফলে সরাসরি আপনার টার্গেটেড কাস্টমারদের সাথে খুব
        সহজেই যোগাযোগ করতে পারবেন।
        <br></br> 
        <strong>বিশেষ সুবিধাঃ</strong> ধরুন, আপনি চায়না থেকে জুতা কিনে এনে শুধুমাত্র আপনার এলাকাতে বিক্রি করতে চান। আপনার টার্গেটেড 
        কাস্টমাররা হল ১৮-২৫ বছরের তরুনরা । কিন্তু শুধু মাত্র তাদেরকেই বিজ্ঞাপনটা দেখাতে চাচ্ছেন , কিভাবে দেখাবেন ? ফেসবুক 
        আপনাকে সেই সুযোগটি দিবে । আপনি আপনার নির্দিষ্ট এলাকাকে পিন করে নির্দিষ্ট বয়স নির্বাচন করে খুব সহজেই টারেগেটেড
        কাস্টমারদের বিজ্ঞাপন দেখাতে পারবেন ।
        
        এভাবে আপনি কম খরচে আপনার টার্গেটেড কাস্টমারদের বিজ্ঞাপন দেখিয়ে আপনার পন্যের বিক্রি বাড়াতে পারবেন ।
        
        </p>
      
      `,
      extras: `বর্তমানে ফেসবুক বিশ্বের সবচেয়ে জনপ্রিয় একটি স্যোসাল মাধ্যম যা বিশ্বের প্রায় আড়াই কোটি মানুষ ব্যবহার করে থাকে । 
      বাংলাদেশের প্রায় ৩ কোটি মানুষের ফেসবুক একাউন্ট `,
      images: [
        {
          fields: {
            file: {
              url: blog3,
            },
          },
        },
        {
          fields: {
            file: {
              url: room2,
            },
          },
        },
        {
          fields: {
            file: {
              url: room3,
            },
          },
        },
        {
          fields: {
            file: {
              url: room4,
            },
          },
        },
      ],
    },
  },
  {
    sys: {
      id: "3",
    },
    fields: {
      name: "ফেসবুকে কত ধরনের বিজ্ঞাপন দেওয়া যায় ?",
      slug: "ফেসবুকে-কত-ধরনের-বিজ্ঞাপন-দেওয়া-যায়",
      type: "ফেসবুকে কত ধরনের বিজ্ঞাপন দেওয়া যায় ?",

      featured: true,
      description: `<p>বাংলাদেশে ফেসবুকে ২ ধরনের বিজ্ঞাপন দেওয়া যায় । যেমনঃ

        ১। বুস্টিং
        
        ২। পেজ পোমোশন
        <br></br>
        </p>
        <br></br>
        <p className="card-text text_justify">
        <strong>১। বুস্টিংঃ</strong> বুস্টিং হল একটি ফেসবুক পেজের কোনো পোস্টকে বিজ্ঞাপন হিসাবে বাছাই করা এবং নির্ধারিত মানুষকে সেই পোস্টটি দেখানো । 
        অর্থাৎ আপনার পেজে যারা লাইক দেই নি , তাদের কে আপনার পোস্টটি দেখানোটাই হল বুস্টিং ।
        <br></br>
        
        ৫ ধরনের বুস্টিং রয়েছেঃ
        <br></br>
        <strong>ক. একক ছবির বুস্টিংঃ </strong>এ ধরনের বুস্টিং এ শুধুমাত্র একটি মাত্র ছবি থাকবে এবং সাথে ক্যাপশন হিসাবে কিছু লিখা থাকবে । একটি মাত্র 
        ছবি থাকায় ফেসবুকের এড টুলসের প্রক্রিয়ায় তেমন কোনো বাধা পায় না( যদিও ছবিতে ২০ ভাগের বেশি লেখা থাকা যাবেনা) তাই এধরনের
        বুস্টিং এ বেশি সংখ্যক মানুষকে দেখানো যায় এবং এটি খুব জনপ্রিয় বুস্টিং ।
        <br></br>
       <strong> খ. বহুছবির পোস্ট বুস্টিংঃ</strong>দুই বা তারও বেশি ছবি থাকবে ও সাথে ক্যাপশন থাকবে । এ ধরনের বুস্টিং এ বেশি ছবির থাকার কারনে এড 
       টুলস কম সংখ্যক মানুষের কাছে পোস্ট রিচ করতে পারে । তবে বেশি ছবি দেওয়ার মাধ্যমে বেশি তথ্য বিজ্ঞাপনের মাধ্যমে দেখানো যায় ।
        <br></br>
       <strong>গ. ভিডিও বুস্টিংঃ</strong>একটি ভিডিওসহ পোস্টকে বুস্টিং করাটাই হল ভিডিও বুস্টিং। ভিডিওর সময় যত কম হবে তত বেশি মানুষ দেখবে । 
        কোনো কোনো ক্ষেত্রে পোস্ট বুস্টিং থেকে ভিডিও বুস্টিং এর রিচ বেশি হয় ।
        <br></br>
       <strong> ঘ. স্লাইড ভিডিও বুস্টিংঃ</strong> কয়েকটি ছবি দিয়ে ১০-২০ সেকেন্ডের স্লাইড ভিডিও বানিয়ে বুস্ট করাই হচ্ছে স্লাইড ভিডিও বুস্টিং। স্লাইড ভিডিও 
        অনেকগুলো পন্য একসাথে দেখানোর জন্য খুব ভালো একটি উপায়। এ ধরনের ভিডিওর রিচ ভালো হয় । ওয়েব সাইট, অ্যাপ ও গ্যামস বুস্টিংঃ
        কোনো ওয়েবসাইটের লিংক কিংবা অ্যাপ/গেমসের ট্রাফিক বাড়ানোর জন্য এ ধরনের বুস্টং করা হয় । এ ধরনের বুস্টিং এর কারনে সাইটে 
        প্রচুর পরিমানে ট্রাফিক পাওয়া যায় ।
        <br></br>
        <strong>২। পেজ প্রমোশনঃ</strong> নতুন করে ফেজবুক পেজে লাইক বৃদ্ধির জন্য এ ধরনের প্রমোশন করা হয় । পেজ প্রমোশনের মাধ্যমে ফেসবুক আপনার
        পেজটিকে অনেক মানুষের কাছে দেখাবে ,এতে করে ব্যবহারকারিরা আপনার পেজের প্রতি আগ্রহী হবে এবং লাইক দিবে । ফলে আপনার 
        পেজে লাইকের সংখ্যা বাড়বে ।
        </p>
        `,
      extras: "বাংলাদেশে ফেসবুকে ২ ধরনের বিজ্ঞাপন দেওয়া যায় । যেমনঃ",
      images: [
        {
          fields: {
            file: {
              url: blog2,
            },
          },
        },
        {
          fields: {
            file: {
              url: room2,
            },
          },
        },
        {
          fields: {
            file: {
              url: room3,
            },
          },
        },
        {
          fields: {
            file: {
              url: room4,
            },
          },
        },
      ],
    },
  },
  {
    sys: {
      id: "4",
    },
    fields: {
      name: "বুস্টিং এর গোল/লক্ষ্য গুলো কি কি?",
      slug: "বুস্টিং-এর-গোল-লক্ষ্য-গুলো-কি-কি",
      type: "বুস্টিং এর গোল/লক্ষ্য গুলো কি কি",

      featured: true,
      description: `

      <p>বর্তমানে অনলাইন / অফলাইন ব্যবসায় অনেকে ফেসবুক বুস্টিং এর সাথে পরিচিত।  শুধু ব্যবসাই নয় কেউ কেউ ব্যক্তিগত ভাবে পেজ খুলে বুস্টিং এর মাধ্যমে হাজার হাজার মানুষের কাছে নিজেকে তুলে ধরছে। বেশির ভাগ মানুষই তার ব্যবসার প্রসার ঘটাতে ও নতুন নতুন কাস্টমার পাওয়ার জন্য বুস্টিং করে থাকে। আপনি কোন উদ্দেশ্য বুস্টিং করবেন তা আপনাকে আগেভাগেই সেট করে ফেলতে হবে যাতে বুস্টিং করে আপনার লক্ষ্য পূরন হয়। 
      <br></br>
      ফেসবুক বুস্টিং এ অনেক ধরনের গোল আছে সেগুলোর মধ্যে সবচেয়ে কমন গোলগুলো/লক্ষ্যগুলো হল-
      <br></br>
      ১. পোস্টে লাইক কমেন্ট বাড়ানো<br></br>
      ২.পেজে বেশি বেশি মেসেজ পাওয়া<br></br>
      ৩. পেজের লাইক বাড়ানো<br></br>
      ৪. ওয়েবসাইটে বেশি বেশি ট্রাফিক ঢোকানো
      <br></br>
      বাংলাদেশে অনলাইন ব্যবসায়ীরা বেশীরভাগ ক্ষেত্রে এই চারটি গোল অর্জনের জন্যই ফেসবুকে বুস্ট/বিজ্ঞাপন দিয়ে থাকে। 
      তো এই লক্ষ্যগুলো বিস্তারিত আলোচনা শুরু করা যাক।
      <br></br>
     <strong> পোস্টে লাইক-কমেন্ট বাড়ানোঃ</strong>
      
       নতুন কোনো অনলাইন ব্যবসায় সম্পর্কে মানুষকে জানাতে বা পোস্টে বেশি লাইক-কমেন্ট পাওয়ার জন্য  এধরনের বুস্টিং গোল নির্বাচন করা হয়। 
      এধরনের বুস্টিং এ প্রচুর মানুষকে আপনার পোস্টটি দেখানো যায় ফলে আপনার নতুন নতুন কাস্টমার পাওয়ার সম্ভাবনা বেড়ে যায়।
      <br></br>
     <strong> পেজে বেশি বেশি মেসেজ পাওয়াঃ</strong>
      
       বুস্টিং এর উদ্দেশ্য যদি হয় মানুষজনক পণ্য কেনার জন্য আপনাকে মেসেজ দিবে তাহলে এ ধরনের বুস্টিং সেট করতে হবে। এধরনের বুস্টিং এ  ফেসবুক নির্দিষ্ট কিছু মানুষজনকে তাদের ইনবক্সে বা মেসেঞ্জারে আপনার পোস্টটি দেখিয়ে আপনার পেজে মেসেজ এনে দিবে।  মেসেজের মাধ্যমে কাস্টমারদের সাথে চ্যাট করার সুযোগ তৈরি হয় এধরনের বুস্টিং এর কারনে। চ্যাট করার কারনে পণ্য বিক্রি করার সুযোগও অনেকগুন বেড়ে যায়। 
       <br></br>
      
     <strong> পেজের লাইক বাড়ানোঃ</strong>
      
       পেজে লাইক বাড়ানো বা নতুন নতুন লাইক পাওয়ার জন্য এ ধরনের বুস্টিং  করা হয়। 
      ধরুন, আপনি একটি ফেসবুক পেজ খুললেন৷ সেখানে কোনো  লাইক নেই৷  প্রথমে আপনি আপনার ফ্রেন্ড লিস্টের পরিচিত বন্ধুদেরকে ইনভাইট পাঠালেন তারা কয়েকজন একসেপ্ট করলো। আপনার পেজের কিছু লাইক বাড়লো।  কিন্তু আপনি চাচ্ছেন আপনার ফ্রেন্ড লিস্টের বাইরেও নির্দিষ্ট এলাকার মনুষ আপনার পেজে লাইক দিবে।  এজন্য আপনাকে ফেসবুকে ডলার দিয়ে  Page Promotion করে লাইক বাড়াতে হবে৷ <br></br>
      
      <strong>ওয়েবসাইটে বেশি বেশি ট্রাফিক ঢোকানোঃ</strong> 
      
      ধরুন, আপনার একটি ওয়েবসাইট আছে কিংবা প্লে স্টোরে আপনার অ্যাপ আছে।  এখন আপনি চাচ্ছেন ফেসবুক থেকে টার্গেটেড কিছু মানুষকে আপনার ওয়েবসাইটে ঢোকাবেন বা অ্যাপ ডাউনলোড করাবেন।  এক্ষেত্রে আপনাকে এ ধরনের বুস্টিং এ যেতে হবে। ফলে আপনি আপনার লক্ষ্য পৌঁছাতে পারবেন৷ 
      <br></br>
      
      খুব দ্রুত ব্যবসার প্রসার ঘটানো, নতুন নতুন কাস্টমার পাওয়া,তাদের সাথে মেসেজে চ্যাট করা, তাদেরকে আপনার ব্যবসার নতুন নতুন কালেকশন দেখানো এবং সর্বোপরি সেল বাড়িয়ে লাভবান হওয়ার জন্য ফেসবুক বুস্টিং এর গুরুত্ব অপরিসীম । </p>`,
      extras:
        "বর্তমানে অনলাইন / অফলাইন ব্যবসায় অনেকে ফেসবুক বুস্টিং এর সাথে পরিচিত।  শুধু ব্যবসাই নয় কেউ কেউ ব্যক্তিগত ভাবে পেজ খুলে বুস্টিং এর মাধ্যমে হাজার হাজার মানুষের কাছে নিজেকে তুলে ধরছে।",
      images: [
        {
          fields: {
            file: {
              url: img4,
            },
          },
        },
        {
          fields: {
            file: {
              url: room2,
            },
          },
        },
        {
          fields: {
            file: {
              url: room3,
            },
          },
        },
        {
          fields: {
            file: {
              url: room4,
            },
          },
        },
      ],
    },
  },
  {
    sys: {
      id: "5",
    },
    fields: {
      name: "ফেসবুক বুস্টিং কি-কেন-কিভাবে?",
      slug: "ফেসবুক-বুস্টিং-কি-কেন-কিভাবে",
      type: "ফেসবুক বুস্টিং কি-কেন-কিভাবে?",

      featured: true,
      description: `

     <p>   ফেসবুুক বুস্টিং হল এক ধরনের বিজ্ঞাপন যেটির মাধ্যমে আপনার পেজের কোনো  একটি পোস্ট আপনার টার্গেটেড কাস্টমারদেরকে দেখাবেন।
        
        যেমনঃ ফেসবুকে আপনার একটি বিজনেস  পেজ আছে।  সেখানে আপনি শার্ট বিক্রি করেন।  এজন্য আপনি বিভিন্ন শার্টের কালেকশনের ছবি ও দামসহ একটি পোস্ট করলেন আপনার পেজে৷ এখন এই পোস্টটি অনেক অনেক মানুষকে দেখাবেন যাতে অনেক মানুষ আপনার শার্ট সম্পর্কে জানতে পারে এবং তারা কেনার জন্য আগ্রহী হয়।
        ফেসবুকে এই অনেক মানুষকে শার্টের পোস্টটি দেখানোটাই হল বুস্টিং।
        <br></br>
        সহজ কথায়, আপনার পেজের ১টি পোস্ট অনেক মানুষকে জানানোর কাজটাই হল বুস্টিং
        <br></br>
        <strong>কেন বুস্টিং করবেন -</strong>
        <br></br>
        যারা ফেসবুকে পেজ খুলে অনলাইন ব্যবসায় করেন তাদের জন্য বুস্টিংটা খু্ব প্রয়োজন।  কারন বুস্টিং এর ফলে আপনার অনলাইন ব্যবসায় সম্পর্কে মানুষজন জানতে থাকে এবং আপনার বেশি বিক্রি হওয়ার সুযোগ বাড়ে।
        <br></br>
        বর্তমানে অনেক অনলাইন ব্যবসায়ী বুস্টিং করে করে তাদের ব্যবসা পরিচালনা করছে এবং নতুন নতুন কাস্টমার পেয়ে লাভবান হচ্ছে।
        <br></br>
        <strong>কিভাবে বুস্টিং করবেন -</strong>
        <br></br>
        ফেসবুক পেজের প্রতিটি পোস্টের নিচে দেখবেন Boost Post নামে একটি বাটন আছে সেখানে ক্লিক করলে বুস্টিং এর জন্য বিভিন্ন  ধরনের বিষয় দেখতে পাবেন।  সেগুলো ঠিকঠাকভাবে সেট করতে হবে।  তারপর বুস্টিং রান করার জন্য সবচেয়ে প্রয়োজনীয় জিনিস- ডুয়েল কারেন্সির ভিসা কার্ড অথবা আন্তর্জাতিক লেনদেন করা যাবে এরকম কার্ডের নম্বর সেখানে ইনপুট দিতে হবে।  বাংলাদেশী টাকার কোনো মাস্টার কার্ড দিয়ে বুস্ট করা যাবে না। অবশ্যই ডলার পেমেন্ট করা যাবে এরকম মাস্টার/ভিসা কার্ড ব্যবহার করতে হবে।  paypal, payoneer অথবা ব্যাংকের ডুয়েল কারেন্সির কার্ড দিয়ে বুস্টিং রান করা যাবে।
        <br></br>
        যাদের এ ধরনের কার্ড নেই কিংবা বানাতে পারছেন না(পাসপোর্ট না থাকার জন্য)  তারা বিভিন্ন এজেন্সির সাথে যোগাযোগ করতে পারেন।  তারা তাদের কার্ডটি ব্যবহার করে আপনার পোস্টটি বুস্টিং করে দিবে৷  বিকাশের মাধ্যমে তাদেরকে আপনি পেমেন্ট করে দিতে পারবেন। 
        </p>
        `,
      extras:
        "ফেসবুুক বুস্টিং হল এক ধরনের বিজ্ঞাপন যেটির মাধ্যমে আপনার পেজের কোনো  একটি পোস্ট আপনার টার্গেটেড কাস্টমারদেরকে দেখাবেন।",
      images: [
        {
          fields: {
            file: {
              url: img5,
            },
          },
        },
        {
          fields: {
            file: {
              url: room2,
            },
          },
        },
        {
          fields: {
            file: {
              url: room3,
            },
          },
        },
        {
          fields: {
            file: {
              url: room4,
            },
          },
        },
      ],
    },
  },
];
